import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { createPageComment, deletePageComment, listPageComments } from '../services/contentService';
import { ensureUserProfile } from '../services/profileService';

function PageComments({ entry, canComment }) {
  const { currentUser } = useAuth();
  const [comments, setComments] = useState([]);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const loadComments = useCallback(async () => {
    if (!entry?.id) return;
    setLoading(true);
    setError('');
    try {
      setComments(await listPageComments(entry.id));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [entry]);

  useEffect(() => {
    loadComments();
  }, [loadComments]);

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    try {
      if (!text.trim()) return;
      const profile = await ensureUserProfile(currentUser);
      await createPageComment(entry, profile, text);
      setText('');
      await loadComments();
    } catch (err) {
      setError(err.message);
    }
  }

  async function handleDelete(commentId) {
    setError('');
    try {
      await deletePageComment(entry.id, commentId);
      await loadComments();
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div className="page-comments">
      <p className="tag">Comments</p>
      {loading ? <p className="muted">Loading comments...</p> : null}
      {error ? <p className="error-text">{error}</p> : null}
      {comments.map((comment) => (
        <article className="page-comment" key={comment.id}>
          <strong>{comment.authorName}</strong>
          <p>{comment.text}</p>
          {currentUser?.uid === comment.authorId || currentUser?.uid === entry.ownerId ? (
            <button className="button button-secondary button-small" type="button" onClick={() => handleDelete(comment.id)}>Delete</button>
          ) : null}
        </article>
      ))}
      {canComment && currentUser ? (
        <form className="comment-form" onSubmit={handleSubmit}>
          <input value={text} onChange={(event) => setText(event.target.value)} placeholder="Add a comment" />
          <button className="button button-secondary button-small" type="submit">Post</button>
        </form>
      ) : null}
      {canComment && !currentUser ? <p className="muted">Log in to comment.</p> : null}
    </div>
  );
}

export default PageComments;
